'use client';

import Link from 'next/link';

export function LogoV2() {
  return (
    <Link href="/" className="flex items-center gap-2 group">
      {/* Logo mark - stylized chart/pulse icon */}
      <div className="relative w-8 h-8 flex items-center justify-center">
        <div className="absolute inset-0 bg-gradient-to-br from-[#d4a853] to-[#b8923f] rounded-lg opacity-20 group-hover:opacity-30 transition-opacity" />
        <svg
          viewBox="0 0 24 24"
          className="w-5 h-5 text-[#d4a853]"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
          <polyline points="16 7 22 7 22 13" />
        </svg>
      </div>
      {/* Logo text */}
      <span className="font-display text-reading-xl font-bold tracking-tight text-[#e6edf3]">
        Traded<span className="text-[#d4a853]">News</span>
      </span>
    </Link>
  );
}
